import {IssueTypeToken} from '@github-ui/issue-type-token'
import type {RelayCompat} from '@github-ui/server-persisted-queries/relay-compat'
import {IssueOpenedIcon} from '@primer/octicons-react'

import {LABELS} from '../constants/labels'
import {createIssueEventExternalUrl} from '../utils/urls'
import type {IssueTypeRemovedEventNode} from './issue-viewer-view-query-types'
import styles from './IssueTypeEvent.module.css'
import {TimelineRow} from './row/TimelineRow'

// RELAY-CLEANUP(IssueTypeRemovedEvent): widens nullable fields so still-Relay parent data is assignable.
// Remove when the timeline pagination fragments leave Relay.
export type IssueTypeRemovedEventFragment = RelayCompat<
  Pick<IssueTypeRemovedEventNode, 'actor' | 'createdAt' | 'databaseId' | 'issueType'>
>

type IssueTypeRemovedEventProps = {
  queryRef: IssueTypeRemovedEventFragment
  issueUrl: string
  onLinkClick?: (event: MouseEvent) => void
  highlightedEventId?: string
  refAttribute?: React.RefObject<HTMLLIElement | null>
  repositoryNameWithOwner?: string
}

export function IssueTypeRemovedEvent({
  queryRef,
  issueUrl,
  onLinkClick,
  highlightedEventId,
  refAttribute,
  repositoryNameWithOwner,
}: IssueTypeRemovedEventProps) {
  const {actor, createdAt, issueType, databaseId} = queryRef

  if (!issueType) {
    return null
  }

  const highlighted = String(databaseId) === highlightedEventId

  const getTooltipText = (isTextTruncated: boolean) => {
    return isTextTruncated ? issueType.name : undefined
  }

  return (
    <TimelineRow
      highlighted={highlighted}
      refAttribute={refAttribute}
      actor={actor}
      createdAt={createdAt}
      deepLinkUrl={createIssueEventExternalUrl(issueUrl, databaseId)}
      onLinkClick={onLinkClick}
      leadingIcon={IssueOpenedIcon}
    >
      <TimelineRow.Main>
        {`${LABELS.timeline.issueTypeRemoved.leading}`}
        <div className={styles.issueTypeTokenWrapper}>
          <IssueTypeToken
            name={issueType.name}
            color={issueType.color}
            href={`/${repositoryNameWithOwner}/issues?q=type:"${issueType.name}"`}
            getTooltipText={getTooltipText}
            size="small"
          />
        </div>
        {`${LABELS.timeline.issueTypeRemoved.trailing} `}
      </TimelineRow.Main>
    </TimelineRow>
  )
}
